import axios from "axios"
import {urlProcessamentos} from "../../../../../constants/endpoints";

export const TIPO_ESTOQUE_GRUPO = 'estoque_grupo';

const getProcessamento = (id) => {
    const response = axios.get(`/processamentos/${id}`);
    const corpo = response?.data ?? response;

    if (corpo?.status) return corpo;
    if (corpo?.data?.status) return corpo.data;

    return corpo;
}

const listaProcessamentos = (id_empresa, tipo = TIPO_ESTOQUE_GRUPO) => axios.get(`${urlProcessamentos}/ativos`, { params: { id_empresa, tipo } });

export function isGrupoTravado(error) {
    return error?.response?.status === 423;
}

export function mensagemGrupoTravado(error) {
    const usuario = error?.response?.data?.usuario;

    return usuario
        ? `${usuario} está atualizando este grupo. Aguarde o processamento terminar para editar novamente.`
        : 'Este grupo está sendo atualizado. Aguarde o processamento terminar para editar novamente.';
}

export function descricaoBloqueio(processamento) {
    if (!processamento) return '';

    const quem = processamento.meu
        ? 'Você salvou este grupo'
        : `${processamento.usuario ?? 'Outro usuário'} está atualizando este grupo`;

    const progresso = processamento.progresso != null ? ` (${processamento.progresso}%)` : '';

    return `${quem}${progresso}. Aguarde o processamento terminar para editar.`;
}

export {
    getProcessamento,
    listaProcessamentos,
}